import React, { useState, useRef, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { Col, Row, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';

import {
  Accomplishment,
  PopupsForAddingState,
  PopupsState,
  ReturnedPortfolio,
} from '../Create-Portfolio/types';
import '../Preview/Preview.css';

import { maxDate, minDate } from '../../config/calendarMinMaxDates';

import { ReactComponent as PlusIcon } from '../../images/plus.svg';
import { ReactComponent as MinusIcon } from '../../images/minus.svg';
import { formatDate, handleNewItemFields } from '../UserProfile/helpers';
import { useFileAmountValidation } from '../Create-Portfolio/customHooks';
import { validationMessages } from '../../config/validationMessages';
import { newlyAddedAccomplishment } from '../Create-Portfolio/initialValues';
import FileUploadComponent from '../FileUploadButton/SingleFileUploadButton';
// import { ReactComponent as DeleteIcon } from '../../images/trash3-fill.svg';
import { API_ROUTES } from '../../config/api-routes';
import axiosInstance from '../../api/api';
import { toast } from 'react-toastify';
import { normalizeUrl } from '../Preview/helpers';
import { refreshPortfolioAfterSave, type PortfolioGetDataFn } from '../../utils/portfolioRefresh';

type ProjectFile = string | { name: string; tempFile: File };

interface Props {
  portfolioId?: number;
  index: number;
  portfolio: ReturnedPortfolio;
  setOpenedPopups: React.Dispatch<React.SetStateAction<PopupsState>>;
  setPopupsToAdd: React.Dispatch<React.SetStateAction<PopupsForAddingState>>;
  setPortfolioData: React.Dispatch<React.SetStateAction<ReturnedPortfolio>>;
  setSavePortfolioButton: React.Dispatch<React.SetStateAction<boolean>>;
  savePortfolioButton: boolean;
  popupVariant: string;
  getData?: PortfolioGetDataFn;
}

interface Accomplishments {
  id?: string | number;
  name: string;
  description?: string;
  links: string[];
  filesUrl: ProjectFile[];
  // …other fields
}

const AccomplishmentPopup: React.FC<Props> = ({
  portfolioId,
  index,
  portfolio,
  setOpenedPopups,
  setPopupsToAdd,
  setPortfolioData,
  setSavePortfolioButton,
  savePortfolioButton,
  popupVariant,
  getData,
}) => {
  const [accomplishments, setAccomplishments] = useState<Accomplishments[]>(
    portfolio.accomplishments as Accomplishments[]
  );
  const [newAccomplishment, setNewAccomplishment] = useState<any>(newlyAddedAccomplishment);
  const [disabled, setDisabled] = useState<boolean>(true);
  //const [success, setAddingFileSuccess] = useState<boolean>(false);
  const [sizeError, setSizeError] = useState<boolean>(false);
  const [pendingFiles, setPendingFiles] = useState<File[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const popupRef = useRef<HTMLDivElement>(null);
  const [uploadDisabled, setUploadDisabled] = useState<Record<number, boolean>>({});

  const { fileError } = useFileAmountValidation(accomplishments[index]?.filesUrl, index);

  /*  const errorWithAmountInNewAccomplishment = useFileAmountValidation(
    newAccomplishment.filesUrl,
    index,
  );
  const errorWithSizeInNewAccomplishment = useFileSizeValidation(
    newAccomplishment.filesUrl,
    index,
  ); */

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        // setPopupsToAdd((prev: PopupsForAddingState) => ({
        //   ...prev,
        //   accomplishments: false,
        // }));
        // setOpenedPopups((prev) => {
        //   const newAccomplishmentsPopups = [...prev.accomplishments];
        //   newAccomplishmentsPopups[index] = false;
        //   return {
        //     ...prev,
        //     accomplishments: newAccomplishmentsPopups,
        //   };
        // });
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [popupRef, setOpenedPopups, setPopupsToAdd, index]);

  useEffect(() => {
    setAccomplishments(portfolio.accomplishments as Accomplishments[]);
  }, [portfolio.accomplishments]);

  const handleSelectFileForNew = (file: File) => {
    const maxSizeInBytes = 10 * 1024 * 1024;
    if (file.size >= maxSizeInBytes) {
      setSizeError(true);
      return;
    }
    setPendingFiles((prev) => [...prev, file]);
    // setDisabled(false);
    setSizeError(false);
    setUploadDisabled((prev) => {
      return { ...prev, [index]: true };
    });
  };

  const removePendingFile = (i: number) => {
    setPendingFiles((prev) => prev.filter((_, idx) => idx !== i));
    setUploadDisabled((prev) => ({ ...prev, [index]: false })); // ✅ re-enable
  };

  /* const handleAccomplishmentSubmit = (index: number) => {
    if (accomplishments.length === undefined) {
      return;
    }

    setSavePortfolioButton(true);
    setTimeout(() => {
      scrollToPortfolioButton();
    }, 0);

    setPortfolioData((prev) => ({ ...prev, accomplishments: accomplishments }));
    toast.success('Accomplishment staged for saving');
    setOpenedPopups((prev) => {
      const newAccomplishmentsPopups = [...prev.accomplishments];
      newAccomplishmentsPopups[index] = false;
      return {
        ...prev,
        accomplishments: newAccomplishmentsPopups,
      };
    });
  }; */

  const handleAccomplishmentSubmit = (e: React.FormEvent<HTMLFormElement>, index: number) => {
    e.preventDefault();

    const updatedProjects = [...accomplishments];

    // ✅ Add just the file names as placeholders for UI
    updatedProjects[index] = {
      ...updatedProjects[index],
      filesUrl: [
        ...(updatedProjects[index].filesUrl || []),
        ...pendingFiles.map((f) => f.name), // only strings
      ],
    };

    setAccomplishments(updatedProjects);

    setPortfolioData((prev) => ({
      ...prev,
      accomplishments: updatedProjects as typeof prev.accomplishments,
    }));

    setSavePortfolioButton(true);
    setDisabled(false);

    setOpenedPopups((prev) => {
      const newProjectsPopups = [...prev.accomplishments];
      newProjectsPopups[index] = false;
      return { ...prev, accomplishments: newProjectsPopups };
    });

    // ⚠️ Keep pendingFiles until upload API call
    // Or clear them if you don’t want duplicates
    setPendingFiles([]);
  };

  /* const handleSubmitOfNewAccomplishment = (
    e: React.FormEvent<HTMLFormElement>,
  ) => {
    e.preventDefault();

    const updatedAccomplishments = [...accomplishments, newAccomplishment];

    setPortfolioData((prev) => ({
      ...prev,
      accomplishments: updatedAccomplishments,
    }));
    setSavePortfolioButton(true);
    setTimeout(() => {
      scrollToPortfolioButton();
    }, 0);

    setPopupsToAdd((prev: PopupsForAddingState) => ({
      ...prev,
      accomplishments: false,
    }));
  }; */

  const handleSubmitOfNewAccomplishment = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Track old ids first
      const existingIds = new Set((portfolio.accomplishments || []).map((p: any) => p.id));

      // Stage the accomplishment
      const stagedAcc = {
        clientUuid: uuidv4(), // 🔑 temp unique key
        id: undefined,
        name: newAccomplishment.name?.trim(),
        date: newAccomplishment.date ? new Date(newAccomplishment.date).toISOString() : null,
        description: newAccomplishment.description?.trim() || null,
        link: normalizeUrl(newAccomplishment.link),
        links: Array.isArray(newAccomplishment.links)
          ? newAccomplishment.links.map(normalizeUrl).filter(Boolean)
          : [],
        filesUrl: [],
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      };

      if (!stagedAcc.name) {
        toast.error('Accomplishment name is required');
        return;
      }

      // Build payload (plural ✅)
      const info = {
        ...portfolio,
        accomplishments: [...(portfolio.accomplishments || []), stagedAcc],
      };

      // Send payload
      const form = new FormData();
      form.append('info', JSON.stringify(info));

      const url = `${API_ROUTES.PORTFOLIO.EDIT_PORTFOLIO}/${portfolioId}`;
      const saveRes = await axiosInstance.post(url, form);

      if (!saveRes || saveRes.status >= 300) {
        throw new Error(`Save failed (${saveRes?.status})`);
      }

      const savedPortfolio = saveRes.data.portfolio;

      // ✅ Find the accomplishment with a *new id*
      const created = savedPortfolio.accomplishments.find(
        (p: any) => !existingIds.has(p.id) && p.name === stagedAcc.name
      );

      if (!created?.id) {
        throw new Error('Could not identify newly created accomplishment id');
      }

      // ✅ Upload files only when new id exists
      if (pendingFiles.length > 0) {
        for (const file of pendingFiles) {
          const infoForUpload = {
            accomplishment: { id: created.id, fileId: uuidv4() }, // singular ✅
          };
          const fd = new FormData();
          fd.append('info', JSON.stringify(infoForUpload));
          fd.append(infoForUpload.accomplishment.fileId, file, file.name);
          await axiosInstance.post(API_ROUTES.PORTFOLIO.UPLOAD_FILES, fd);
        }
      }

      toast.success('Accomplishments added');
      setPendingFiles([]);
      setNewAccomplishment(created);
      setPopupsToAdd((prev) => ({ ...prev, accomplishments: false }));
      /*  setSavePortfolioButton(true);
      setTimeout(() => {
        scrollToPortfolioButton();
      }, 0); */

      await refreshPortfolioAfterSave(setPortfolioData, savedPortfolio, getData);
    } catch (err: any) {
      console.error(err);
      toast.error(err?.message || 'Failed to add accomplishments');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDeleteFile = (accIndex: number, fileIndex: number, fileItem: any) => {
    if (fileItem instanceof File) {
      // Pending file (remove from pendingFilesMap)
      setPendingFiles((prev) => prev.filter((_, idx) => idx !== fileIndex));
      setUploadDisabled((prev) => ({ ...prev, [accIndex]: false }));
      toast.success('Pending file removed');
    } else {
      // Existing file (mark for deletion in DB)
      const updatedFiles = accomplishments[accIndex].filesUrl.filter(
        (_: any, idx: number) => idx !== fileIndex
      );
      const updatedItem = {
        ...accomplishments[accIndex],
        filesUrl: updatedFiles,
      };
      const updatedList = [...accomplishments];
      updatedList[accIndex] = updatedItem;

      setUploadDisabled((prev) => ({ ...prev, [accIndex]: false }));

      setAccomplishments(updatedList);
      setDisabled(false);
      setSavePortfolioButton(true);
    }
  };

  const handleInputChange = (
    index: number,
    field: string,
    value: string,
    array: any,
    setItems: React.Dispatch<React.SetStateAction<any>>
  ) => {
    const itemIndex = array.findIndex((_: any, prIndex: number) => prIndex === index);

    if (itemIndex !== -1) {
      const updatedItems = [...array];
      updatedItems[itemIndex] = {
        ...updatedItems[itemIndex],
        [field]: value,
      };
      setItems(updatedItems);
      setDisabled(false);
      //setSavePortfolioButton(true);
    }
  };

  /*  const handleFileChange = async (index: number, file: File, array: any[]) => {
    const maxSizeInBytes = 10 * 1024 * 1024;

    if (file.size >= maxSizeInBytes) {
      setSizeError(true);
      return;
    }

    const data: FormData = new FormData();

    const info = {
      accomplishment: { id: array[index].id, fileId: uuidv4() },
    };

    data.append('info', JSON.stringify(info));

    data.append(info.accomplishment.fileId, file, file.name);

    try {
      const response = await axiosInstance.post(
        API_ROUTES.PORTFOLIO.UPLOAD_FILES,
        data,
      );

      if (!response || response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      setAddingFileSuccess(true);

      const result = await response.data;
      getData();
      console.log('Portfolio files uploaded successfully', result);
    } catch (error) {
      console.error('Failed to upload portfolio files:', error);
    }
  }; */

  const handleFileChange = (index: number, file: File) => {
    const maxSizeInBytes = 10 * 1024 * 1024;

    if (file.size >= maxSizeInBytes) {
      setSizeError(true);
      return;
    }

    // Stash the actual File for later upload
    setPendingFiles((prev) => [...prev, file]);

    setDisabled(false);
    setSavePortfolioButton(true);
    setSizeError(false);

    setUploadDisabled((prev) => {
      return { ...prev, [index]: true };
    });
  };

  const handleAccomplishmentLinkChange = (
    linkIndex: number,
    value: string,
    accomplishmentIndex: number
  ) => {
    const updatedAccomplishments = [...accomplishments];
    const updatedLinks = [...updatedAccomplishments[accomplishmentIndex].links];
    updatedLinks[linkIndex] = value;
    updatedAccomplishments[accomplishmentIndex].links = updatedLinks;
    setAccomplishments(updatedAccomplishments);
  };

  const handleNewAccomplishmentLinkChange = (linkIndex: number, value: string) => {
    setNewAccomplishment((prevAccomplishment: Accomplishment) => {
      const updatedLinks = [...prevAccomplishment.links];
      updatedLinks[linkIndex] = value;
      return {
        ...prevAccomplishment,
        links: updatedLinks,
      };
    });
  };

  const removeLink = (linkIndex: number) => {
    const updatedLinks = [...accomplishments[index].links];
    updatedLinks.splice(linkIndex, 1);
    const updatedAccomplishments = [...accomplishments];
    updatedAccomplishments[index].links = updatedLinks;
    setAccomplishments(updatedAccomplishments);
    setDisabled(false);
    //setSavePortfolioButton(true);
  };

  const addLink = (index: number) => {
    const updatedLinks = [...accomplishments[index].links, ''];
    const updatedAccomplishments = [...accomplishments];
    updatedAccomplishments[index].links = updatedLinks;
    setAccomplishments(updatedAccomplishments);
  };

  const addLinkInNewAccomplishment = () => {
    setNewAccomplishment((prevAccomplishment: Accomplishment) => ({
      ...prevAccomplishment,
      links: [...prevAccomplishment.links, ''],
    }));
  };

  const removeLinkFromNewAccomplishment = (linkIndexToRemove: number) => {
    setNewAccomplishment((prevAccomplishment: Accomplishment) => ({
      ...prevAccomplishment,
      links: prevAccomplishment.links.filter((_, index) => index !== linkIndexToRemove),
    }));
    setDisabled(false);
  };

  return (
    <Card
      className={`${popupVariant === 'adding' ? '' : 'user-popup'} p-3 popup-card`}
      ref={popupRef}
      onMouseDown={(e) => e.stopPropagation()} // ✅ Prevent click propagation
    >
      <Card.Header className="popup-header">
        <div className="header-icon">📁</div>
        <div>
          <div className="header-title">
            {popupVariant === 'adding' ? 'Add Accomplishment' : 'Edit Accomplishment'}
          </div>
        </div>
      </Card.Header>
      <Card.Body className="scrollable-card">
        {popupVariant === 'adding' ? (
          /* -------------------- ADD ACCOMPLISHMENT -------------------- */
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmitOfNewAccomplishment(e);
            }}
          >
            {/* Title */}
            <div className="section">
              <Form.Group as={Row} className="mb-3">
                <Col sm={12}>
                  <Form.Control
                    type="text"
                    required
                    placeholder="Enter a title"
                    onChange={(e) =>
                      handleNewItemFields('name', e.target.value, setNewAccomplishment)
                    }
                  />
                </Col>
              </Form.Group>
            </div>

            {/* Date */}
            <div className="section">
              <Form.Group as={Row} className="mb-3">
                <Col sm={12}>
                  <Form.Control
                    type="date"
                    required
                    onChange={(e) =>
                      handleNewItemFields('date', e.target.value, setNewAccomplishment)
                    }
                    min={minDate}
                    max={maxDate}
                  />
                </Col>
              </Form.Group>
            </div>

            {/* Description */}
            <div className="section">
              <Form.Group as={Row} className="mb-3">
                <Col sm={12} style={{ position: 'relative' }}>
                  <Form.Control
                    as="textarea"
                    rows={6}
                    required
                    className="popup-textarea"
                    placeholder="Enter a description"
                    maxLength={50}
                    onChange={(e) =>
                      handleNewItemFields('description', e.target.value, setNewAccomplishment)
                    }
                  />
                  <span className="textarea-placeholder">Max: 50 characters</span>
                </Col>
              </Form.Group>
            </div>

            {/* Links (ADD) */}
            <div className="section">
              <Form.Label className="mb-2">Links (optional)</Form.Label>
              {(newAccomplishment.links?.length ? newAccomplishment.links : []).map(
                (link: string, linkIndex: number) => (
                  <Form.Group as={Row} className="mb-3" key={linkIndex}>
                    <Col sm={12}>
                      <Form.Control
                        type="text"
                        value={link}
                        placeholder="Enter a link (optional)"
                        onChange={(e) =>
                          handleNewAccomplishmentLinkChange(linkIndex, e.target.value)
                        }
                      />
                      <div
                        className={
                          linkIndex > 0 ? 'links-toggle-button-wrapper' : 'links-add-btn-wrapper'
                        }
                      >
                        {linkIndex > 0 && (
                          <button
                            type="button"
                            onClick={() => removeLinkFromNewAccomplishment(linkIndex)}
                          >
                            <MinusIcon className="icons-size" />
                            <span className="underline-text">Remove link</span>
                          </button>
                        )}
                        <button type="button" onClick={addLinkInNewAccomplishment}>
                          <PlusIcon className="icons-size" />
                          <span className="underline-text">Add link</span>
                        </button>
                      </div>
                    </Col>
                  </Form.Group>
                )
              )}
              {!newAccomplishment.links?.length ? (
                <div className="portfolio-optional-link-row">
                  <button
                    type="button"
                    className="portfolio-optional-link-trigger"
                    onClick={addLinkInNewAccomplishment}
                  >
                    <PlusIcon className="icons-size" aria-hidden />
                    <span>Add link</span>
                  </button>
                </div>
              ) : null}
            </div>

            {/* Files (ADD) */}
            <div className="section">
              <Form.Group as={Row} className="mb-3">
                <Col xs={12} className="file-upload-section">
                  <div className="file-chip-wrap">
                    {pendingFiles.map((f, i) => (
                      <span key={i} className="file-chip" title={f.name}>
                        <span className="file-dot" />
                        <span className="file-chip-text">
                          {f.name.length > 34
                            ? `${f.name.slice(0, 20)}…${f.name.slice(-10)}`
                            : f.name}
                        </span>
                        <button
                          type="button"
                          className="chip-remove"
                          onClick={() => removePendingFile(i)}
                        >
                          ×
                        </button>
                      </span>
                    ))}
                  </div>

                  <FileUploadComponent
                    key={pendingFiles.length}
                    handleFileChange={(file: File) => {
                      if (pendingFiles.length >= 1) {
                        toast.error('You can only upload one file at a time');
                        return;
                      }
                      handleSelectFileForNew(file);
                    }}
                    disabled={pendingFiles.length >= 1}
                  />
                  <small className="text-muted d-block mt-1">Max file size: 10MB</small>

                  {sizeError && (
                    <Alert variant="danger">{validationMessages.FILES_EXCEEDED_LIMIT_10MB}</Alert>
                  )}
                </Col>
              </Form.Group>
            </div>

            {/* Actions */}
            <div className="sticky-actions">
              <Button
                variant="outline-secondary"
                onClick={() =>
                  setPopupsToAdd((prev) => ({
                    ...prev,
                    accomplishments: false,
                  }))
                }
              >
                Cancel
              </Button>
              <Button variant="success" type="submit" disabled={isSubmitting}>
                {isSubmitting ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Submitting...
                  </>
                ) : (
                  'Submit'
                )}
              </Button>
            </div>
          </Form>
        ) : (
          /* -------------------- EDIT ACCOMPLISHMENT -------------------- */
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              handleAccomplishmentSubmit(e, index);
            }}
          >
            {/* Title */}
            <div className="section">
              <Form.Group as={Row} className="mb-3">
                <Form.Label column sm={12}>
                  Title
                </Form.Label>
                <Col sm={12}>
                  <Form.Control
                    type="text"
                    required
                    defaultValue={portfolio.accomplishments[index].name}
                    onChange={(e) =>
                      handleInputChange(
                        index,
                        'name',
                        e.target.value,
                        accomplishments,
                        setAccomplishments
                      )
                    }
                  />
                </Col>
              </Form.Group>
            </div>

            {/* Date */}
            <div className="section">
              <Form.Group as={Row} className="mb-3">
                <Form.Label column sm={12}>
                  Date
                </Form.Label>
                <Col sm={12}>
                  <Form.Control
                    type="date"
                    required
                    defaultValue={formatDate(portfolio.accomplishments[index].date)}
                    onChange={(e) =>
                      handleInputChange(
                        index,
                        'date',
                        e.target.value,
                        accomplishments,
                        setAccomplishments
                      )
                    }
                    min={minDate}
                    max={maxDate}
                  />
                </Col>
              </Form.Group>
            </div>

            {/* Description */}
            <div className="section">
              <Form.Group as={Row} className="mb-3">
                <Form.Label column sm={12}>
                  Description
                </Form.Label>
                <Col sm={12} style={{ position: 'relative' }}>
                  <Form.Control
                    as="textarea"
                    rows={6}
                    className="popup-textarea"
                    required
                    maxLength={50}
                    defaultValue={portfolio.accomplishments[index].description}
                    onChange={(e) =>
                      handleInputChange(
                        index,
                        'description',
                        e.target.value,
                        accomplishments,
                        setAccomplishments
                      )
                    }
                  />
                  <span className="textarea-placeholder">Max: 50 characters</span>
                </Col>
              </Form.Group>
            </div>

            {/* Links (EDIT) */}
            <div className="section">
              <Form.Label column sm={12}>
                Links (optional)
              </Form.Label>
              {(accomplishments[index].links?.length ? accomplishments[index].links : []).map(
                (link: string, linkIndex: number) => (
                  <div key={linkIndex}>
                    <Form.Group as={Row} className="mb-3">
                      <Col sm={12}>
                        <Form.Control
                          type="text"
                          value={link}
                          placeholder="Enter a link (optional)"
                          onChange={(e) => {
                            setDisabled(false);
                            setSavePortfolioButton(true);
                            handleAccomplishmentLinkChange(linkIndex, e.target.value, index);
                          }}
                        />
                        <div
                          className={
                            linkIndex > 0 ? 'links-toggle-button-wrapper' : 'links-add-btn-wrapper'
                          }
                        >
                          {linkIndex > 0 && (
                            <button type="button" onClick={() => removeLink(linkIndex)}>
                              <MinusIcon className="icons-size" />
                              <span className="underline-text">Remove link</span>
                            </button>
                          )}
                          <button type="button" onClick={() => addLink(index)}>
                            <PlusIcon className="icons-size" />
                            <span className="underline-text">Add link</span>
                          </button>
                        </div>
                      </Col>
                    </Form.Group>
                  </div>
                )
              )}
              {!accomplishments[index].links?.length ? (
                <div className="portfolio-optional-link-row">
                  <button
                    type="button"
                    className="portfolio-optional-link-trigger"
                    onClick={() => addLink(index)}
                  >
                    <PlusIcon className="icons-size" aria-hidden />
                    <span>Add link</span>
                  </button>
                </div>
              ) : null}
            </div>

            {/* Files (EDIT) */}
            <div className="section">
              <Form.Group as={Row} className="mb-3">
                <Form.Label column sm={12}>
                  Upload Supporting Files
                </Form.Label>
                <Col sm={12} className="file-upload-section">
                  <div className="file-chip-wrap">
                    {[...(accomplishments[index].filesUrl || []), ...(pendingFiles || [])].map(
                      (fileItem: any, fileIndex: number) => {
                        const fileName =
                          fileItem?.name ||
                          fileItem?.file?.name ||
                          fileItem.toString().replace(/_/g, ' ').split('/').pop();

                        return (
                          <span key={fileIndex} className="file-chip" title={fileName}>
                            <span className="file-dot" />
                            <span className="file-chip-text">
                              {fileName.length > 34
                                ? `${fileName.slice(0, 20)}…${fileName.slice(-10)}`
                                : fileName}
                            </span>
                            <button
                              type="button"
                              className="chip-remove"
                              onClick={() => handleDeleteFile(index, fileIndex, fileItem)}
                            >
                              ×
                            </button>
                          </span>
                        );
                      }
                    )}
                  </div>

                  {accomplishments[index].filesUrl.length + pendingFiles.length < 1 && (
                    <div className="select-project-file">
                      <FileUploadComponent
                        handleFileChange={(file: File) => {
                          const total =
                            (accomplishments[index]?.filesUrl?.length || 0) + pendingFiles.length;
                          if (total >= 1) {
                            toast.error('You can only upload one file at a time');
                            return;
                          }
                          handleFileChange(index, file);
                        }}
                        disabled={uploadDisabled[index]}
                      />
                      <small className="text-muted d-block mt-1">Max file size: 10MB</small>
                    </div>
                  )}

                  {fileError && <Alert variant="danger">{fileError}</Alert>}
                  {sizeError && (
                    <Alert variant="danger">{validationMessages.FILES_EXCEEDED_LIMIT_10MB}</Alert>
                  )}
                </Col>
              </Form.Group>
            </div>

            {/* Actions */}
            <div className="sticky-actions">
              <Button
                variant="outline-secondary"
                onClick={() =>
                  setOpenedPopups((prev) => {
                    const newAccPopups = [...prev.accomplishments];
                    newAccPopups[index] = false;
                    return { ...prev, accomplishments: newAccPopups };
                  })
                }
              >
                Cancel
              </Button>
              <Button variant="success" type="submit" disabled={disabled}>
                Submit
              </Button>
            </div>
          </Form>
        )}
      </Card.Body>
    </Card>
  );
};

export default AccomplishmentPopup;
